// extracted by mini-css-extract-plugin
export default {"result":"ErrorPage_result__NlZ3z","image":"ErrorPage_image__HNeRm"};